<template>
  <div style="overflow: auto">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="add-ruleForm">
      <div class="body-title">
        基本信息
        <div class="underline"></div>
      </div>
      <div class="form-row">
        <el-form-item label="客户名称" prop="customerName">
          <el-input v-model.trim="ruleForm.customerName" placeholder="请输入客户名称" maxlength="30" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户级别">
          <el-select v-model="ruleForm.customerLevelId" placeholder="请选择客户级别" style="width: 100%" clearable>
            <el-option
                v-for="item in customerLevelOptions"
                :key="item.id"
                :label="item.description"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="form-row">
        <el-form-item label="税号">
          <el-input v-model.trim="ruleForm.taxNumber" placeholder="请输入税号" clearable maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="来源">
          <el-select v-model="ruleForm.formSourceId" placeholder="请选择来源" style="width: 100%" clearable>
            <el-option
                v-for="item in customerSourceOptions"
                :key="item.id"
                :label="item.description"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="form-row">
        <el-form-item label="网址" prop="url">
          <el-input v-model.trim="ruleForm.url" placeholder="请输入网址" maxlength="100" clearable></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="tel">
          <el-input v-model.trim="ruleForm.tel" placeholder="请输入电话" maxlength="30" clearable></el-input>
        </el-form-item>
      </div>
      <div class="form-row">
        <el-form-item label="邮箱" prop="email">
          <el-input v-model.trim="ruleForm.email" placeholder="请输入邮件" maxlength="30" clearable></el-input>
        </el-form-item>
        <el-form-item label="传真" prop="fax">
          <el-input v-model.trim="ruleForm.fax" placeholder="请输入传真" maxlength="30" clearable></el-input>
        </el-form-item>
      </div>

      <div class="form-row">
        <el-form-item label="联系人" prop="linkName">
          <el-input v-model.trim="ruleForm.linkName" :disabled="Boolean(customerId)" :placeholder="`请输入${ customerId?'或选择':'' }联系人`" maxlength="30" clearable>
            <el-button slot="append" v-if="customerId" @click="selectLinker">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="linkPhone">
          <el-input v-model.trim="ruleForm.linkPhone" :disabled="Boolean(customerId)" placeholder="请输入联系电话" maxlength="30" clearable></el-input>
        </el-form-item>
      </div>

      <div class="form-row">
        <el-form-item label="负责人">
          <el-input placeholder="请选择负责人" v-model="ruleForm.chargeName" disabled>
            <el-button slot="append" @click="dialogVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="归属部门" prop="name">
          <el-select v-model="ruleForm.chargeDeptId" placeholder="请选择部门" style="width: 100%">
            <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.departmentName"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div class="form-row">
        <el-form-item label="所属行业：" prop="industryClassName">
          <div class="insIput">
            <div class="tag-div" v-if="ruleForm.industryClassName">
              <el-tag type="info" style="margin-right: 5px" v-for="(item,index) in ruleForm.industryClassName.split(',')"
                      :key="index">{{ item }}
              </el-tag>
            </div>
            <div class="industBtn" @click="openIndustry">选择</div>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea"
                    :rows="4"
                    v-model.trim="ruleForm.remark"
                    maxlength="300"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </div>
      <div class="body-title">
        地区定位
        <div class="underline"></div>
      </div>
      <el-form-item label="定位" prop="name">
        <Map @receiveAddress="receiveAddress"></Map>
      </el-form-item>
      <el-form-item label="省市区" prop="province">
        <div class="shengInput">
          <el-input v-model="ruleForm.province" placeholder="省" readonly></el-input>
          <el-input style="margin: 0 20px" v-model="ruleForm.city" placeholder="市" readonly></el-input>
          <el-input v-model="ruleForm.district" placeholder="区" readonly></el-input>
        </div>
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
        <el-input v-model.trim="ruleForm.address" placeholder="请输入详细地址" ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即保存</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
        title="选择人员"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        width="50%">
      <role-user :isMultiple="false" @selectionChange="selectUser"></role-user>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择所属行业 -->
    <EnterTree ref="EnterTree" @getIndustry="getIndustry"></EnterTree>
    <!-- 选择联系人 -->
    <selectLinker ref="selectLinker" @confirmSelect="getLinker"/>
  </div>
</template>

<script>
import Map from "@/components/mapold"
import roleUser from "@/components/role-user"
import EnterTree from "@/components/enter-tree"
import { CustomerApis, DictionaryApis } from "@/apis";
import { DictionaryKey } from "@/utils/enum";
import selectLinker from '@/components/select-linker'

export default {
  data() {
    return {
      dialogVisible: false,
      customerId: this.$route.query.id,
      ruleForm: {
        id:0,
        customerName: '',
        customerLevelId: '',
        customerLevelName: '',
        // 税号
        taxNumber: '',
        formSourceId: '',
        formSourceName: '',
        tel: '',
        email: '',
        fax: '',
        url: '',
        compId:"",
        chargeId: '',
        chargeName: '',
        chargeDeptId: '',
        chargeDeptName: '',
        remark: '',
        // 地址
        province: '',
        city: '',
        district: '',
        address: '',
        mapLng: '',
        mapLat: '',

        industryClassCode: '',
        industryClassName: '',
        industryParentIds: '',
        linkId: 0,
        linkName: '',
        linkPhone: '',
      },
      rules: {
        customerName: [
          {required: true, message: '请输入客户名称', trigger: 'change'},
        ],
        province: [
          {required: true, message: '请在地图上选择地址', trigger: 'change'}
        ],
        linkName: [
          {required: true, message: '请输入联系人', trigger: 'change'}
        ],
        linkPhone: [
          {required: true, message: '请输入联系电话', trigger: 'change'}
        ],
      },
      customerLevelOptions: '',
      customerSourceOptions: '',
      departmentList: [],
      selectIndustry: [],
    };
  },
  mounted() {
    // 处理breadcrumb
    const curBread = this.$store.state.breadcrumb.find(i=>i.path === '/add-customer');
    if(curBread) curBread.title = this.customerId ? "修改客户": "添加客户";

    this.getOptions();
    if(this.customerId) this.getCustomerInfo();
  },
  methods: {
    async getCustomerInfo(){
      let res = await CustomerApis.getCustDataById(this.customerId);
      // 处理id为0的情况
      res.customerLevelId === '0' && (res.customerLevelId = '');
      res.formSourceId === '0' && (res.formSourceId = '');
      this.departmentList = res.chargeId && await this.$axios.get(`/Crm/Department/DepartmentByUId?userId=${ res.chargeId }`);
      if( !this.departmentList.length ) {
        this.departmentList = [{
          id: res.chargeDeptId || 0,
          departmentName: res.chargeDeptName || '总公司'
        }]
      }
      for (const key in this.ruleForm) {
        this.ruleForm[key] = res[key];
      }
      // 联系人和联系电话
      // this.ruleForm.linkId = res.linkUserList[0].id;
      // this.ruleForm.linkName = res.linkUserList[0].linkName;
      // this.ruleForm.linkPhone = res.linkUserList[0].linkPhone;
      if( this.customerId ) {
        this.rules.linkName[0].message = `请输入或选择联系人`;
      }


      const codes = res.industryClassCode.split(",");
      const names = res.industryClassName.split(",");
      codes.forEach((code, index) => {
        this.selectIndustry.push({ id: code, cName: names[index] });
      });
    },
    async getOptions() {
      const levelPromise = DictionaryApis.getDictValueByKey(DictionaryKey.CustLevel);
      const sourcePromise = DictionaryApis.getDictValueByKey(DictionaryKey.CustSource);
      const [ levelOptions, sourceOptions ] = await Promise.all([levelPromise,sourcePromise])
      this.customerLevelOptions = levelOptions;
      this.customerSourceOptions = sourceOptions;
    },
    receiveAddress(address, position) {
      ['province','city','district','address'].forEach( r => {
        this.ruleForm[r] = address[r]
      })
      this.ruleForm.mapLat = position.lat;
      this.ruleForm.mapLng = position.lng;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.customerLevelId && (this.ruleForm.customerLevelName = this.customerLevelOptions.find( f=> f.id === this.ruleForm.customerLevelId).description);
          this.ruleForm.formSourceId && (this.ruleForm.formSourceName = this.customerSourceOptions.find( f=> f.id === this.ruleForm.formSourceId).description);
          this.ruleForm.chargeDeptId && (this.ruleForm.chargeDeptName = this.departmentList.find( f=> f.id === this.ruleForm.chargeDeptId).departmentName);

          delete this.ruleForm.industrySmallClassInfo;
          // 联系人和联系人电话
          this.ruleForm.linkUserList = [{
            id: this.ruleForm.linkId || 0,
            linkName: this.ruleForm.linkName,
            linkPhone: this.ruleForm.linkPhone
          }]

          if(this.customerId) {
            CustomerApis.modifyCustomerInfo(this.ruleForm).then(res=>{
              this.$message.success(`修改成功！`);
              this.$router.back();
            })
          } else {
            this.$axios.post(`/Crm/Customer/AddCustomerInfo`,this.ruleForm).then(() => {
              this.$message.success(`添加成功！`);
              this.$router.push(`/customer-manage`);
            })
          }
        }
      });
    },
    selectUser(info) {
      this.dialogVisible = false;
      this.ruleForm.chargeId = info.id;
      this.ruleForm.chargeName = info.realName;
      this.departmentList = info.departmentList;
      if (!info.departmentList || !info.departmentList.length) {
        this.departmentList = [{ id: "0", departmentName: "总公司" }]; // 没有部门时要处理成总公司
      }
      this.ruleForm.chargeDeptId = this.departmentList[0].id;
      this.ruleForm.chargeDeptName = this.departmentList[0].departmentName;
    },
    //选择行业
    openIndustry() {
      this.$refs.EnterTree.open({
        selectIndustry: this.selectIndustry,
        industryParentIds: this.ruleForm.industryParentIds,
      })
    },
    getIndustry(info) {
      this.ruleForm.industrySmallClassInfo = info.selectIndustry;
      this.selectIndustry = info.selectIndustry;
      this.ruleForm.industryParentIds = info.industryParentIds;
      let showIndustryName = '';
      let selectId = [];
      if (this.ruleForm.industrySmallClassInfo) {
        if (this.ruleForm.industrySmallClassInfo.length > 0) {
          this.ruleForm.industrySmallClassInfo.forEach((item, index) => {
            showIndustryName = showIndustryName ? showIndustryName + ',' + item.cName : item.cName;
            selectId.push(item.id);
          });
        }
      }
      this.ruleForm.industryClassCode = selectId.join(',');
      this.ruleForm.industryClassName = showIndustryName;
    },

    //选择联系人
    selectLinker() {
      this.axios.get(`/Crm/Customer/CustomerLinkerListById?customerId=${ this.customerId }`).then(res => {
        if(res || res.length) {
          this.$refs.selectLinker.open(res);
        } else {
          this.$message.warning('这是旧数据，请删除！')
        }

      })
    },
    getLinker(row) {
      this.ruleForm.linkId = row.id;
      this.ruleForm.linkName = row.linkName;
      this.ruleForm.linkPhone = row.linkPhone;
    },
    // 清空联系人信息
    // clearLinkerInfo() {
    //   this.ruleForm.linkId = '';
    //   this.ruleForm.linkPhone = '';
    // }

  },
  components: {
    Map,
    roleUser,
    EnterTree,
    selectLinker
  }
}
</script>

<style scoped lang="scss">
.body-title {
  position: relative;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 30px;

  .underline {
    position: absolute;
    bottom: -3px;
    width: 22px;
    height: 3px;
    background: #46a0fc;
    border-radius: 2px;
  }

  .icon-css {
    cursor: pointer;
  }
}
.add-ruleForm {
  width: 70%;

  .shengInput {
    display: flex;
  }

  .form-row {
    display: flex;

    .el-form-item {
      flex: 1;
      .insIput {
        display: flex;
        //height: 32px;
        //line-height: 32px;
        width: 100%;

        .industBtn {
          border: 1px solid #DCDFE6;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          border-radius: 0 3px 3px 0;
          background-color: #F5F7FA;
          color: #909399;
          width: 60px;
        }

        .tag-div {
          border: 1px solid #DCDFE6;
          border-right: 0;
          border-radius: 4px 0 0 4px;
          padding: 0 10px;
          //display: flex;
          //align-items: center;
          width: 100%;
        }
      }
    }
  }


}
</style>
